import { Button } from 'src/UI';
import { FC } from 'react';
import { Hint } from '@redoc/ui-kit';
import { ReactComponent as ChevronIcon } from 'src/Themes/assets/chevron-left.svg';
import classNames from 'classnames';
import st from './SubMenuFooter.module.scss';

interface ISubMenuFooterProps {
	id: string;
	expanded?: boolean;
	disabled?: boolean;
	toggleExpand: () => void;
	renderFooter?: FC<ISubMenuFooterProps>;
}

const SubMenuFooter: FC<ISubMenuFooterProps> = (props) => {
	const {
		id,
		expanded = true,
		disabled = false,
		toggleExpand,
		renderFooter,
	} = props;
	const expandButtonHint = expanded ? 'Свернуть ' : 'Развернуть ';

	return (
		<div id={id + '_footer'} className={st.footer}>
			<div className={st.footer__userPart}>
				{renderFooter && renderFooter(props)}
			</div>
			<Hint messageText={expandButtonHint} placement="top">
				<Button
					id={id + '_expandBtn'}
					className={classNames(st.footer__expandBtn, {
						[st.notExpanded]: !expanded,
					})}
					outline
					disable={disabled}
					onClick={toggleExpand}
				>
					<ChevronIcon />
				</Button>
			</Hint>
		</div>
	);
};

export default SubMenuFooter;
